import { defineComponent as _defineComponent } from 'vue'
import AzImg from '~/components/Atoms/AzImg.vue';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchCard',
  props: {
  link: {
    type: String,
    default: '',
  },
  name: {
    type: String,
    default: '',
  },
  category: {
    type: String,
    default: '',
  },
  image: {
    type: [Array, Object, String],
    default: '',
  },
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props;





return { __sfc: true,props, emit, AzImg, NuxtLinkCustom }
}

})